import { render, staticRenderFns } from "./billing_portal_button.vue?vue&type=template&id=47c483be&"
import script from "./billing_portal_button.vue?vue&type=script&lang=js&"
export * from "./billing_portal_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports